(() => {
  const contextKey = 'avo_statsig_context_v2';
  const contextTtlMs = 604800000;
  let activeClient = null;
  let activeContext = null;
  let pendingStart = null;
  let startRegistered = false;
  const privacyState = () => {
    const privacy = window.Shopify?.customerPrivacy || window.Shopify?.trackingConsent;
    return privacy?.analyticsProcessingAllowed?.() ?? null;
  };
  function clearContext() {
    activeContext = null;
    try { window.localStorage.removeItem(contextKey); } catch {}
  }
  function runtimeOptions(allowed = privacyState()) {
    return {
      loggingEnabled: allowed === true ? 'browser-only' : 'disabled',
      disableStorage: allowed !== true,
    };
  }
  function syncClient() {
    const allowed = privacyState();
    if (activeClient) activeClient.updateRuntimeOptions(runtimeOptions(allowed));
    if (allowed !== true) {
      if (allowed === false) clearContext();
      return;
    }
    if (pendingStart) {
      const start = pendingStart;
      pendingStart = null;
      start(runtimeOptions(allowed));
    }
    if (!activeClient) return;
    try {
      const stableID = activeClient.getContext().stableID;
      if (!stableID) {
        clearContext();
        return;
      }
      const context = {
        version: 2, stableID, environment: window.statsigOptions.environment.tier,
        expiresAt: Date.now() + contextTtlMs,
      };
      window.localStorage.setItem(contextKey, JSON.stringify(context));
      activeContext = context;
    } catch { clearContext(); }
  }
  window.avoStatsigMetrics = {
    runtimeOptions,
    whenAllowed(start) {
      if (startRegistered) return;
      startRegistered = true;
      pendingStart = start;
      const prepare = () => {
        syncClient();
        if (privacyState() !== null) return;
        window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error) syncClient();
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
      else prepare();
    },
    connect(client) {
      activeClient = client;
      syncClient();
    },
  };
  const recordClick = (event) => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    if (event.type === 'click' && event.button !== 0) return;
    if (privacyState() !== true || !activeClient || !activeContext) return;
    if (Date.now() >= activeContext.expiresAt) return;
    const link = event.target.closest?.('a.product-card__link, a.product-card__image-link');
    const card = link?.closest('[data-avo-product-id]');
    const productId = card?.dataset.avoProductId;
    if (!productId) return;
    try {
      if (activeClient.getContext().stableID !== activeContext.stableID) return;
      const path = window.location.pathname;
      const publicPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[\w-]+(?:\/products\/[\w-]+)?|products\/[\w-]+|pages\/[\w-]+|search)\/?$/i;
      activeClient.logEvent('product_clicked', null, {
        schema_version: '1', source: 'theme_product_card', environment: activeContext.environment,
        product_id: productId,
        collection_handle: card.dataset.avoCollectionHandle || '',
        source_path: path === '/' || publicPath.test(path) ? path : '',
        destination_path: link.pathname,
      });
    } catch {}
  };
  document.addEventListener('click', recordClick);
  document.addEventListener('auxclick', recordClick);
  document.addEventListener('visitorConsentCollected', syncClient);
  window.addEventListener('PandectesEvent_OnConsent', syncClient);
  syncClient();
})();
